import * as React from 'react';
import { connect } from 'react-redux';
import FloatingBox from 'components/FloatingBox';
import { Boxes } from 'reducers/floatingBoxes';

type Props = {
  boxes: Boxes;
};

/* This component is responsible for showing floating boxes.
 * It's pretty limited ATM but this is where limiting the number
 * of displayed floating boxes logic might be if we need this one day.
 */
class FloatingBoxes extends React.Component<Props> {
  render() {
    const items = [];

    for (const mapEntry of this.props.boxes) {
      const [uuid, box] = mapEntry;

      if (box.type && box.type.WIDTH && box.type.POSITION) {
        if (
          (box.type.POSITION === 'bottom-right' || box.type.POSITION === 'bottom-left') &&
          !box.type.HEIGHT
        ) {
          console.error(
            `Cannot render a floating box in a bottom position without a height.`,
            `We tried to look for a static property called HEIGHT defined on ${
              box.type && box.type.name
            }`,
            `but we found: ${box.type && box.type.HEIGHT}`
          );
        } else {
          items.push(
            <FloatingBox
              width={box.type.WIDTH}
              position={box.type.POSITION}
              height={box.type.HEIGHT}
              key={uuid}
              suppressTextSelection={box.type.SUPPRESS_TEXT_SELECTION}
            >
              {box}
            </FloatingBox>
          );
        }
      } else if (!box.type.WIDTH) {
        console.error(
          `Cannot render a floating box without a width.`,
          `We tried to look for a static property called WIDTH defined on ${
            box.type && box.type.name
          }`,
          `but we found: ${box.type && box.type.WIDTH}`
        );
      }
    }

    return <div>{items}</div>;
  }
}

function mapStateToProps(state: any) {
  return {
    boxes: state.floatingBoxes.boxes,
  };
}

export { FloatingBoxes };
export default connect(mapStateToProps)(FloatingBoxes);
